import { FixedSizeVirtualScrollStrategy } from '@angular/cdk/scrolling';
import { Injectable } from '@angular/core';
import { distinctUntilChanged, filter, map } from 'rxjs/operators';

import { ObservableScope } from '../shared/models/observable-scope.enum';
import { EventService } from '../shared/services/event.service';
import { AngularEvents } from '../shared/shared-context/angular-events';

@Injectable()
export class CardScrollStrategy extends FixedSizeVirtualScrollStrategy {
    constructor(
        private readonly eventService: EventService
    ) {
        super(
            217,
            217 * 2,
            217 * 4);

        this.eventService.events.withScope(ObservableScope.PastAndFuture).pipe(
            filter(event => event.name === AngularEvents.recommendedCardSize),
            map(event => ({ size: event.args[0], num: event.args[1] })),
            distinctUntilChanged((a, b) => a.size === b.size && a.num === b.num)
        ).subscribe(({ size, num }) => {
            this.updateItemAndBufferSize(size, size * (num + 1), size * (num + 3));
        });
    }
}
